require.register("modules/m0x/a02/page-17-co/page-17-co", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_17co = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_17co;

  
});

